import { svgs } from "public/assets/svgs"

interface ButtonProps {
  handler?: () => void
  label: string
  customClass?: string
  // icon?: string
  icon?: keyof typeof svgs
  fillColor?: string
  disabled? : boolean
  dataCy?: string
}

const OutlineButton: React.FC<ButtonProps> = ({ handler, label, customClass, icon, fillColor, dataCy, }) => {
  return (
    <button
      onClick={handler}
      data-cy={dataCy} 
      className={`${
        customClass || ""
      } ml-2 flex h-auto flex-shrink-0 flex-grow-0 items-center  justify-center gap-1 overflow-auto rounded border border-[#7C737E] bg-white px-2 py-1 text-sm font-semibold text-[#070109] `}
    >
      {icon && <div className="flex items-center"> {svgs[icon]?.({ fill: fillColor, height: 16, width: 17 })}</div>}
      {label}
    </button>
  )
}

export default OutlineButton
